import ct from "class-types.macro";

const getCustomFlexClasses = (
  isSupervisor: boolean,
  isOrderGuideEnabled: boolean
) => {
  if (isSupervisor !== isOrderGuideEnabled) {
    return "flex-row-1685";
  }
  if (isSupervisor && isOrderGuideEnabled) {
    return "flex-row-1865";
  }
  return "flex-row-1500";
};

const getCenterLinkClasses = (
  isSupervisor: boolean,
  isOrderGuideEnabled: boolean
) =>
  !isSupervisor && !isOrderGuideEnabled
    ? "lt:flex lt:flex-row lt:justify-center lt:space-x-20 lg:space-x-24"
    : "xl:flex xl:flex-row";

const baseClasses = ct(
  "w-full",
  "grid",
  "grid-cols-1",
  "xxxs:grid-cols-2",
  "pl-2",
  "sm:pl-4",
  "gap-y-2",
  "lt:gap-y-0",
  "gap-x-8",
  "xl:gap-x-0",
  "justify-between",
  "pr-0",
  "xl:pr-4"
);
const getContainerClasses = (
  showingMessages: boolean,
  isSupervisor: boolean,
  isOrderGuideEnabled: boolean
) =>
  `${baseClasses} ${
    showingMessages
      ? getCustomFlexClasses(isSupervisor, isOrderGuideEnabled)
      : getCenterLinkClasses(isSupervisor, isOrderGuideEnabled)
  }`;

export default getContainerClasses;
